import api from '@js/middlewares/api';

export const spyHeartbeat = (value) => {
    if (window.isMetricsEnabled) {
        window._paq.push(['enableHeartBeatTimer', value]);
    }
};

export const spyWaypoint = (eventName, positionName) => {
    if (window.isMetricsEnabled) {
        window._paq.push(['trackEvent', eventName, positionName]);
    }
};

export const spySearchForm = (type) => () => {
    setTimeout(() => {
        if (window.isMetricsEnabled) {
            window._paq.push(['trackEvent', 'Search form', type]);
        }
    }, 50);
};

export const spySearchResults = (searchParams, response) => {
    if (window.isMetricsEnabled) {
        const keywords = [searchParams.query, searchParams.location && searchParams.location.place_name].compact().join(', ');
        let totalResults = 0;
        for (const resultType in response.totalCount) {
            if (response.totalCount.hasOwnProperty(resultType)) {
                totalResults += response.totalCount[resultType];
            }
        }

        window._paq.push(['trackSiteSearch', keywords, 'Search', totalResults]);
    }
};

export const spyTrackView = (elementName, elementId, parentName = null, parentId = null) => {
    if (process.env.NODE_ENV === 'production' && !window.seoMode) {
        return api
            .post((parentName && parentId)
                ? `/api/${parentName}s/${parentId}/${elementName}s/${elementId}/viewed`
                : `/api/${elementName}s/${elementId}/viewed`,
                {
                    id: elementId
                });
    } else {
        return new Promise((resolve) => {
            resolve();
        });
    }
};

export const spyTrackClick = (elementName, elementId, parentName = null, parentId = null) => {
    if (process.env.NODE_ENV === 'production' && !window.seoMode) {
        return api
            .post((parentName && parentId)
                ? `/api/${parentName}s/${parentId}/${elementName}s/${elementId}/clicked`
                : `/api/${elementName}s/${elementId}/clicked`,
                {
                    id: elementId,
                    userId: window.currentUserId ? parseInt(window.currentUserId, 10) : undefined
                });
    } else {
        return new Promise((resolve) => {
            resolve();
        });
    }
};
